import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, IconButton, Menu, Tooltip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { usePagination } from './utils/usePagination';
/**
 * TODO: Move this to tetris once this feature branch is merged.
 */
export function Pagination(props) {
    const { limit = 0, count = 0, offset = 0, setOffset, disabled, maxCount = Number.POSITIVE_INFINITY } = props;
    const { pages, goto, current, totalPages } = usePagination({
        count,
        limit,
        offset,
        setOffset,
    });
    const notActive = pages.length < 2;
    const pageStartCount = offset + 1;
    const pageEndCount = offset + limit > count ? count : offset + limit;
    const paginationDisabled = notActive || disabled;
    const prevDisabled = disabled || notActive || current === 0;
    const nextDisabled = disabled || notActive || current === totalPages - 1;
    const numberFormatter = new Intl.NumberFormat();
    const countToDisplay = count > maxCount ? `${numberFormatter.format(maxCount)}+` : numberFormatter.format(count);
    return (<Box gap="sm" alignItems="center">
      <Menu.Root target={<Tooltip title={t({ comment: 'Pagination: Select page tooltip', message: 'Select page' })}>
            <Button type="button" disabled={paginationDisabled} appearance="ghost" size="xs" style={{ textWrap: 'nowrap' }}>
              <Trans comment="Pagination: Page range">
                {pageStartCount} - {pageEndCount} of {countToDisplay}
              </Trans>
            </Button>
          </Tooltip>}>
        <Menu.Item onClick={() => goto('first')}>
          <Trans comment="Pagination: First page button">First page</Trans>
        </Menu.Item>
        <Menu.Divider />
        {pages.map(({ index, offset: pageOffset, number }) => (<Menu.Item key={index} selected={offset === pageOffset} onClick={() => goto(index)}>
            <Trans comment="Pagination list item">Page {number}</Trans>
          </Menu.Item>))}
        <Menu.Divider />
        <Menu.Item onClick={() => goto('last')}>
          <Trans comment="Pagination: Last page button">Last page</Trans>
        </Menu.Item>
      </Menu.Root>

      <IconButton type="button" disabled={prevDisabled} appearance="ghost" onClick={() => goto(current - 1)} size="xs" aria-label={t({ message: 'Previous page', comment: 'Pagination: Previous page tooltip' })}>
        <Falcon icon="chevron-left"/>
      </IconButton>

      <IconButton type="button" disabled={nextDisabled} appearance="ghost" onClick={() => goto(current + 1)} size="xs" aria-label={t({ message: 'Next page', comment: 'Pagination: Next page tooltip' })}>
        <Falcon icon="chevron-right"/>
      </IconButton>
    </Box>);
}
